var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsersdigi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14731_237033)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.81127 11.1091C9.62502 11.1091 11.0953 9.63876 11.0953 7.82502V5.63563C11.0953 3.82189 9.62502 2.35156 7.81127 2.35156C5.99753 2.35156 4.5272 3.82189 4.5272 5.63563V7.82502C4.5272 9.63876 5.99753 11.1091 7.81127 11.1091ZM7.81127 11.1091C11.4388 11.1091 15.4741 13.392 15.4741 16.8801V17.6772C15.4741 18.2818 14.984 18.7719 14.3794 18.7719H1.24313C0.638547 18.7719 0.148438 18.2818 0.148438 17.6772V16.8801C0.148438 13.392 4.18379 11.1091 7.81127 11.1091Z",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2113 2.54688C13.4754 3.00381 14.3788 4.21454 14.3788 5.63628V6.73097C14.3788 8.15087 13.451 9.55675 12.1895 10.015C12.9276 9.00927 13.2961 7.73184 13.2951 6.18273C13.294 4.63363 12.9327 3.42168 12.2113 2.54688ZM17.6629 18.7726H18.7576C19.3622 18.7726 19.8523 18.2825 19.8523 17.6779C19.8523 17.4122 19.8523 17.1465 19.8523 16.8807C19.8523 14.5054 17.981 12.689 15.6415 11.7718C15.6415 11.7718 18.7576 14.3938 17.6629 18.7726Z",
    fill: "inherit",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14731_237033"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.648438)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersdigi);
export default __webpack_public_path__ + "static/media/usersdigi.7b3c50c34da4d8c6b76265f9cf817646.svg";
export { ForwardRef as ReactComponent };